import { ScrollReveal } from './ScrollReveal';
import { ShieldCheck, Lock, UserCheck, Eye, Layers, Globe, Settings, Users } from 'lucide-react';
import { useLang } from '@/lib/translations';

const ICONS = [Lock, Users, UserCheck, Eye, ShieldCheck, Layers, Settings, Globe];

export default function SecurityTrust() {
  const { t } = useLang();
  const s = t.security;
  return (
    <section id="security" className="relative py-24 sm:py-32 overflow-hidden" data-testid="security-trust-section">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-aurocle-gold/5 rounded-full blur-[200px] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <ScrollReveal>
          <div className="overline mb-4">{s.overline}</div>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-aurocle-text mb-4">{s.title}</h2>
          <p className="text-base text-aurocle-platinum-muted max-w-2xl mb-16">{s.sub}</p>
        </ScrollReveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {s.pillars.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <ScrollReveal key={i} delay={i * 60}>
                <div className="premium-card p-6 h-full" data-testid={`security-pillar-${i}`}>
                  <div className="relative z-10">
                    <Icon size={20} className="text-aurocle-gold mb-4" />
                    <h3 className="font-heading text-sm font-medium text-aurocle-text mb-2">{p.t}</h3>
                    <p className="text-xs text-aurocle-platinum-muted leading-relaxed">{p.d}</p>
                  </div>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
        <ScrollReveal delay={400}>
          <div className="mt-16 flex flex-wrap items-center justify-center gap-6 text-xs font-mono uppercase tracking-wider text-aurocle-text-secondary">
            {s.strip.map((item) => (<span key={item} className="px-4 py-2 border border-white/6">{item}</span>))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
